<template>
  <v-banner
    v-model="value"
    :single-line="singleLine && !$vuetify.breakpoint.smAndDown"
    :style="{ backgroundColor: backgroundColor, position: bannerPosition, width: '100%', top: bannerPositionTop, zIndex: '6','--banner-p-top': bannerPaddingTop}"
    sticky>
    <slot name="icon">
      <v-icon
        slot="icon"
        :color="$finColors.primaryDark"
        size="34"
      >
        {{ icon }}
      </v-icon>
    </slot>
    <slot>
      {{ bannerText }}
    </slot>
    <template #actions="{ dismiss }">
      <v-btn
        :color="$finColors.primaryDark"
        icon
        @click="dismiss"
      >
        <v-icon>icon-close</v-icon>
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  name: "FinBanner",

  data() {
    return {
      value: true,
    }
  },
  props: {
    bannerText: {
      type: String
    },
    bannerPosition: {
      type: String,
      default: 'sticky'
    },
    bannerPositionTop: {
      type: [String, Number],
      default: 0
    },
    bannerPaddingTop:{
      type: [String, Number],
      default: "15px"
    },
    backgroundColor: {
      type: String,
      default: '#61C378'
    },
    singleLine: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'icon-mail'
    }
  },
  watch: {
    bannerText() {
      if (this.bannerText) {
        this.value = true
      }
    },
    value() {
      if (!this.value) {
        this.$emit("closeBanner")
      }
    }
  }
}
</script>

<style lang="scss">
/* IMPORTANT!!!: Do not set to scoped */
@import "../../../styles/home";


.v-banner__wrapper {
  padding-top: var(--banner-p-top) !important;
  padding-bottom: 4px;

  .v-banner__content {
    max-width: unset;
    hyphens: none;

    .v-banner__text {
      align-self: flex-start;
    }

    .v-banner__icon {
      align-self: flex-start;
      top: -5px;
    }

    @media only screen and (max-width: 960px) {
      max-width: 90%;
    }
    @media only screen and (max-width: 1264px) {
      max-width: 98%;
    }
  }

  .v-banner__actions {
    padding-top: 0;
    align-self: flex-start;
    margin-top: -5px;
    @media only screen and (max-width: 960px) {
      max-width: 10%;
    }
    @media only screen and (max-width: 1264px) {
      max-width: 2%;
    }
  }
}
</style>
